import React from 'react'
import styled from 'styled-components'
export const Wrapper = styled.div`
  padding: 20px 4px;
`

export const ShortlistBox = styled.div`
  background: #ddfaef;
  border: 1px solid #58b981;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 20px;
`

export const RejectBox = styled.div`
  background: #FFEDEB;
  border: 1px solid #E35E50;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 20px;
`

export const Title = styled.div`
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 6px;
`

export const Description = styled.div`
  font-size: 14px;
  color: #2f2f2f;
  line-height: 1.5;
`

export const Section = styled.div`
  margin-bottom: 18px;
`

export const Heading = styled.div`
  font-family: Plus Jakarta Sans;
  font-weight: 800;
  font-style: ExtraBold;
  font-size: 12px;
  leading-trim: NONE;
  line-height: 18px;
  letter-spacing: 0%;
  margin-bottom: 6px;
`

export const Text = styled.div`
  font-family: Plus Jakarta Sans;
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 18px;
  letter-spacing: 0%;
`

export const TagContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

export const Tag = styled.div`
  background: #E5E5E5;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 13px;
  color: #333;
`

export const ResponsesWrapper = styled.div`
  padding: 20px 6px;
`

export const Field = styled.div`
  margin-bottom: 18px;
`

export const Label = styled.div`
  /* color: #8c8c8c; */
  font-family: Plus Jakarta Sans;
  font-weight: 400;
  font-style: Regular;
  font-size: 12px;
  leading-trim: NONE;
  line-height: 18px;
  letter-spacing: 0%;

`

export const Value = styled.div`
  font-family: Plus Jakarta Sans;
  font-weight: 700;
  font-style: Bold;
  font-size: 12px;
  leading-trim: NONE;
  line-height: 18px;
  letter-spacing: 0%;

`